export default __webpack_public_path__ + "static/media/cockpit-Header-Mobile.85ae3c4f.jpg";